const SIDEBAR_STORAGE_KEY = 'sidebar_state'

export function readStoredSidebarOpen(defaultOpen = true) {
  if (typeof window === 'undefined') return defaultOpen

  try {
    const stored = window.localStorage.getItem(SIDEBAR_STORAGE_KEY)
    return stored === null ? defaultOpen : stored === 'true'
  } catch {
    return defaultOpen
  }
}

export function writeStoredSidebarOpen(open: boolean) {
  try {
    window.localStorage.setItem(SIDEBAR_STORAGE_KEY, String(open))
  } catch {
    // Storage can be unavailable in restricted browsing contexts.
  }
}
